import { createTheme } from '@material-ui/core/styles';

const DHITheme = createTheme({
  palette: {
    primary: {
      main: '#0B4566', // DHI Primary color
    },
    secondary: {
      main: '#3d6079', // Automatically generated secondary color
    },
  },
});

export default DHITheme;
